// extracted by mini-css-extract-plugin
module.exports = {"arrow":"CarouselArrow_arrow__0uTsq","next":"CarouselArrow_next__eCOvx","prev":"CarouselArrow_prev__B_V59","circleBorder":"CarouselArrow_circleBorder__d8gs5"};